import React, { FC } from 'react';
import { View } from 'react-native';

import { COLORS } from '../../config/designSystem/Colors';
import { CongratsBadge } from './CongratsBadge';
import { H4, ParagraphMRegular } from '../../config/designSystem/typography';
import { ProgressStreak } from '../presenters/ProgressStreak/ProgressStreak';
import { SPACING } from '../../config/designSystem/Spacing';

/**
 * figma: ❖ Congrats screen (Activities & Challenges pt1, nodes 9484-50206 /
 * 9484-52395): hexagon badge + headline (+ day chain for an ongoing
 * challenge). Rendered INSIDE the branching session — never as a route.
 */
interface ChallengeCongratsFrameProps {
  headline: string;
  subtitle?: string;
  days?: { done: boolean }[];
  designSystemColor?: string | null;
  /** the whole challenge is finished: flower badge, no day chain */
  completed?: boolean;
}

export const ChallengeCongratsFrame: FC<ChallengeCongratsFrameProps> = ({
  headline,
  subtitle,
  days,
  designSystemColor,
  completed,
}) => {
  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        rowGap: SPACING['sp-24'],
        paddingHorizontal: SPACING['sp-16'],
      }}
    >
      <CongratsBadge
        kind={completed ? 'flower' : 'confettis'}
        designSystemColor={designSystemColor}
      />
      <H4 align={true}>{headline}</H4>
      {!!subtitle && (
        <ParagraphMRegular align={true} color={COLORS.content.secondary}>
          {subtitle}
        </ParagraphMRegular>
      )}
      {!completed && !!days && days.length > 0 && (
        <ProgressStreak days={days} bare={true} />
      )}
    </View>
  );
};
